import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const user = useSelector((state) => state.user);
  const location = useLocation();

  // Replace this with your actual authentication check
  const isAuthenticated = !!user?.token;

  if (!isAuthenticated) {
    // Redirect to login with the current path and query as redirect param
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;